export default {
  text: 'To make use of the platform, you need a user. Choose below if you already have an account or if you want to create one.',
  signIn: 'Sign in',
  signUp: 'Create new user'
}